import { useState, useEffect } from "react";
import AxiosClient from "../../../../Network/AxiosClient";

export default function useOnlyParamFetch(url, params) {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // if (params == null) {
    //   setData([]);
    //   return;
    // }

    setLoading(true);
    setData(null);
    setError(null);

    AxiosClient.get(`${process.env.REACT_APP_API_URL}/api${url}`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
      },
      params,
    })
      .then((res) => {
        setLoading(false);
        //checking for multiple responses for more flexibility
        //with the url we send in.
        res.data && setData(res.data.data);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.message);
      });
    return () => {};
  }, [url, params]);

  return { data, isLoading, error };
}
